'use client';

import { useTranslations } from 'next-intl';
import { Box, Container, Typography, Grid } from '@mui/material';
import { LandingHeader, LandingFooter } from '../../../features/landing';
import { BlogCard } from './components/BlogCard';
import type { BlogPostMeta } from './lib/posts';

interface BlogListContentProps {
  posts: BlogPostMeta[];
}

export function BlogListContent({ posts }: BlogListContentProps) {
  const t = useTranslations('creator.blog');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <LandingHeader />

      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 }, flex: 1 }}>
        <Typography
          variant="h3"
          component="h1"
          sx={{ fontWeight: 700, mb: 1, textAlign: 'center' }}
        >
          {t('pageTitle')}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 5, textAlign: 'center', maxWidth: 600, mx: 'auto' }}
        >
          {t('pageDescription')}
        </Typography>

        {posts.length === 0 ? (
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ textAlign: 'center', py: 8 }}
          >
            {t('noPosts')}
          </Typography>
        ) : (
          <Grid container spacing={3}>
            {posts.map((post) => (
              <Grid key={post.slug} size={{ xs: 12, sm: 6, md: 4 }}>
                <BlogCard post={post} />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>

      <LandingFooter />
    </Box>
  );
}
